import { Controller } from "@hotwired/stimulus"

export default class extends Controller<HTMLFormElement> {
  static override targets = ["submit", "status"]

  declare readonly submitTarget: HTMLInputElement | HTMLButtonElement
  declare readonly hasSubmitTarget: boolean
  declare readonly statusTarget: HTMLElement
  declare readonly hasStatusTarget: boolean

  private idleText = ""

  submit() {
    if (this.hasSubmitTarget) {
      this.idleText = this.buttonText
      this.submitTarget.disabled = true
      this.submitTarget.setAttribute("aria-busy", "true")
      this.buttonText = this.submitTarget.dataset.loadingText || "Working..."
    }

    if (this.hasStatusTarget) {
      this.statusTarget.hidden = false
    }
  }

  complete(event: CustomEvent<{ success: boolean }>) {
    if (event.detail.success) return

    this.reset()
  }

  private reset() {
    if (this.hasSubmitTarget) {
      this.submitTarget.disabled = false
      this.submitTarget.removeAttribute("aria-busy")
      this.buttonText = this.idleText
    }

    if (this.hasStatusTarget) {
      this.statusTarget.hidden = true
    }
  }

  private get buttonText() {
    if (this.submitTarget instanceof HTMLInputElement) {
      return this.submitTarget.value
    }

    return this.submitTarget.textContent || ""
  }

  private set buttonText(text: string) {
    if (this.submitTarget instanceof HTMLInputElement) {
      this.submitTarget.value = text
      return
    }

    this.submitTarget.textContent = text
  }
}
